module.exports = __webpack_public_path__ + "img/chat2.a9fb16c7.png";